
export default {
    account: {},
    isLoggedIn: false
}
